import React, { useState } from "react";
import {
    Button,
    MessageBar,
    MessageBarActions,
    MessageBarBody,
    MessageBarTitle
} from "@fluentui/react-components";
import { DismissRegular } from "@fluentui/react-icons";
import { motion, AnimatePresence } from "framer-motion";

function MessageBox({ intent, title, message, closeButtonFunction }) {

    return (
        <AnimatePresence>
            {(
                <motion.div
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 0.2 }}
                >
                    <MessageBar intent={intent}>
                        <MessageBarBody style={{ textWrap: "wrap" }}>
                            <MessageBarTitle>{title}</MessageBarTitle>
                            {message}
                        </MessageBarBody>
                        <MessageBarActions>
                            <Button
                                as={`a`}
                                className={`button`}
                                appearance="subtle"
                                icon={<DismissRegular />}
                                onClick={closeButtonFunction}
                            />
                        </MessageBarActions>
                    </MessageBar>
                </motion.div>
            )}
        </AnimatePresence>
    );
}

export default MessageBox;
